const sizeToClassMap = {
  small: 'c-quantity-selector--small',
  large: 'c-quantity-selector--large',
};

export const QUANTITY_SELECTOR_SIZES = Object.keys(sizeToClassMap);
export const QUANTITY_SELECTOR_CLASS_MAP = {
  size: sizeToClassMap,
};
